/**
 * Minimal RFC 4180 CSV encoder + browser download trigger.
 */

// A string cell starting with = + - @ tab or CR is read as a formula by Excel/Sheets
// (CSV/formula injection, OWASP) — merchant names are merchant-controlled input, so a
// leading quote defuses it without changing what the cell displays. Real numbers (e.g.
// -3) are never prefixed, only values that were originally strings.
const FORMULA_LEAD = /^[=+\-@\t\r]/;

export function toCsv(rows: Array<Array<string | number | null | undefined>>): string {
  const escape = (field: string | number | null | undefined): string => {
    if (field == null) return '';
    const s = typeof field === 'string' && FORMULA_LEAD.test(field) ? `'${field}` : String(field);
    return /[",\r\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
  };
  return rows.map((row) => row.map(escape).join(',')).join('\r\n');
}

const UTF8_BOM = String.fromCharCode(0xfeff);

export function downloadCsv(filename: string, csv: string): void {
  // BOM so Excel detects UTF-8 and renders Arabic merchant names correctly.
  const blob = new Blob([UTF8_BOM + csv], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
